import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { chatGroupType, getchartList, hdChat } from "@/api/dataAll/chartMonitor";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "chatMonitor",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      chartTypeArr: [{
        label: this.$t('guildChat'),
        value: "1"
      }, {
        label: this.$t('privateChat'),
        value: "2"
      }, {
        label: this.$t('worldChat'),
        value: "3"
      }],
      hdchartTypeArr: [{
        label: this.$t('systemChannel'),
        value: "0"
      }, {
        label: this.$t('worldChannelLocal'),
        value: "1"
      }, {
        label: this.$t('crossServerChannel'),
        value: "2"
      }, {
        label: this.$t('privateChatChannel'),
        value: "3"
      }, {
        label: this.$t('guildChannel'),
        value: "4"
      }, {
        label: this.$t('strongholdTempChannel'),
        value: "5"
      }, {
        label: this.$t('strongholdTempSystemChannel'),
        value: "6"
      }],
      PointTime: [new Date(new Date().setHours(0, 0, 0, 0)), new Date(new Date().setHours(23, 59, 59, 0))],
      groupList: [],
      searchData: {
        is_group: '2',
        to_group_id: '',
        kind: 1,
        is_history: '2',
        page_time: 0,
        user_id: '',
        page_user_id: '',
        to_user_id: '',
        page: 1
      },
      isFn: true,
      searchDis_group: '2',
      tableData: [],
      reqLoading: false,
      scrollContainer: null,
      isQuer: true,
      serverList: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.rawData.game_mark.indexOf('yjfm') == -1) {
                _this.getServer();
              } // const end = new Date();
              // const start = new Date();
              // start.setTime(start.getTime() - 3600000);
              // this.PointTime = [start,end]
              // console.log("PointTime",this.PointTime)


            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    getServer: function getServer() {
      var _this2 = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this2.serverList = res.data;
        }
      });
    },
    groupChange: function groupChange(e) {
      var _this3 = this;

      this.searchData.to_group_id = '';
      this.searchData.user_id = '';
      this.searchData.to_user_id = '';

      if (e == '1') {
        chatGroupType(this.searchData).then(function (res) {
          if (res.status == 200) {
            _this3.groupList = res.data.filter(function (item) {
              return item != "3";
            });
            _this3.searchData.to_group_id = _this3.groupList;
          }
        });
      }
    },
    searchClick: function searchClick(page) {
      this.isQuer = true;
      this.getList(page);
    },
    // 传时间戳的分页
    getList: function getList() {
      var _this4 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var st = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      // if ((this.value2 && this.value2.length > 0)) {
      //   this.searchData.starttime = this.value2[0]+' '+this.PointTime[0];
      //   this.searchData.endtime = this.value2[1]+' '+this.PointTime[1];
      // }
      this.searchData.starttime = this.timestampToDateTime(Math.floor(this.PointTime[0] / 1000));
      this.searchData.endtime = this.timestampToDateTime(Math.floor(this.PointTime[1] / 1000));

      if (this.searchData.is_group == '1' && this.searchData.to_group_id.length == 0 && this.rawData.game_mark.indexOf('yjfm') != -1) {
        this.$message.error(this.$t('pleaseSelectGroup'));
        return;
      }

      this.reqLoading = true;
      this.searchData.is_history = type;

      if (st) {
        this.searchData.is_history = '2';
        this.searchData.page_time = 0;
        this.tableData = [];
      }

      if (!this.isQuer && type == 1) {
        this.reqLoading = false;
        return;
      }

      var req = this.rawData.game_mark.indexOf('yjfm') == -1 ? hdChat : getchartList;
      req(_objectSpread(_objectSpread({}, this.searchData), {}, {
        server_id: this.paramsData.server_id
      })).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
          var list;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (res.status == 200) {
                    if (res.data.length) {
                      _this4.isQuer = _this4.searchData.page_time == res.data[res.data.length - 1].time && type == 1 ? false : true;
                      _this4.searchDis_group = _this4.searchData.is_group;
                      list = type == 1 ? [].concat(_toConsumableArray(_this4.tableData), _toConsumableArray(res.data)) : [].concat(_toConsumableArray(res.data), _toConsumableArray(_this4.tableData));
                      _this4.tableData = list; //this.tableData = await this.fnTo(list)

                      _this4.$nextTick(function () {
                        _this4.containerFn();
                      });
                    }
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).finally(function () {
        _this4.reqLoading = false;
      });
    },
    containerFn: function containerFn() {
      var that = this;
      this.scrollContainer = document.getElementById('scrollContainer');
      this.scrollContainer.addEventListener('scroll', this.scFn);
      var container = document.getElementById('scrollContainer');

      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    },
    scFn: function scFn() {
      var that = this;

      if (!this.reqLoading) {
        if (this.scrollContainer.scrollHeight - this.scrollContainer.scrollTop === this.scrollContainer.clientHeight) {
          that.searchData.is_history = '1';
          that.searchData.page_time = that.tableData[that.tableData.length - 1].time;
          that.searchData.page_user_id = that.tableData[that.tableData.length - 1].user_id;
          that.getList(1, false);
        }

        if (this.scrollContainer.scrollTop === 0) {
          that.searchData.is_history = '2';
          that.searchData.page_time = that.tableData[0].time;
          that.searchData.page_user_id = that.tableData[0].user_id;
          that.getList(2, false);
        }
      }
    },
    // 去重
    fnTo: function fnTo(list) {
      var newArr = [];

      for (var i = 0; i < list.length; i++) {
        if (newArr.indexOf(list[i].user_id + list[i].content + list[i].time) == -1) {
          newArr.push(list[i].user_id + list[i].content + list[i].time);
        } else {
          list.splice(i, 1);
          i--;
        }
      }

      console.log(list);
      return list;
    },
    exportdata: function exportdata() {
      var columns = [];

      if (this.searchDis_group == '2') {
        columns = [{
          label: this.$t('senderServerId'),
          prop: 'server_id'
        }, {
          label: 'role_name',
          prop: 'role_name'
        }, {
          label: 'role_id',
          prop: 'role_id'
        }, {
          label: 'to_role_name',
          prop: 'to_role_name'
        }, {
          label: 'to_role_id',
          prop: 'to_role_id'
        }, {
          label: this.$t('time'),
          prop: 'time'
        }, {
          label: this.$t('content'),
          prop: 'content'
        }];
      } else {
        columns = [{
          label: this.$t('senderServerId'),
          prop: 'server_id'
        }, {
          label: this.$t('guildId'),
          prop: 'to_group_id'
        }, {
          label: 'role_name',
          prop: 'role_name'
        }, {
          label: 'role_id',
          prop: 'role_id'
        }, {
          label: this.$t('time'),
          prop: 'time'
        }, {
          label: this.$t('content'),
          prop: 'content'
        }];
      }

      if (this.searchDis_group == "3") {
        columns.splice(1, 1);
      }

      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    } // 传页码的分页
    // getList(page = 1) {
    //   if (this.value2.length > 0) {
    //     this.searchData.starttime = this.value2[0];
    //     this.searchData.endtime = this.value2[1];
    //   }
    //   if (this.searchData.is_group == '1' && !this.searchData.to_group_id) {
    //     this.$message.error('请选择群组')
    //     return
    //   }
    //   this.reqLoading = true
    //   this.searchData.page = page
    //   getchartList(this.searchData).then((res) => {
    //     if (res.status == 200) {
    //       this.searchDis_group = this.searchData.is_group
    //       this.tableData = page == 1 ? res.data.data : [...this.tableData, ...res.data.data]
    //       this.isFn = res.data.data.length ? true : false
    //       this.$nextTick(() => {
    //         this.containerFn()
    //       })
    //     }
    //   }).finally(() => {
    //     this.reqLoading = false
    //   });
    // },
    // containerFn() {
    //   let that = this
    //   this.scrollContainer = document.getElementById('scrollContainer');
    //   this.scrollContainer.addEventListener('scroll', this.scFn);
    // },
    // scFn() {
    //   let that = this
    //   if (!this.reqLoading) {
    //     if (this.scrollContainer.scrollHeight - this.scrollContainer.scrollTop === this.scrollContainer.clientHeight) {
    //       if(that.isFn){
    //         let page = this.searchData.page + 1
    //         that.searchClick(page)
    //       }
    //     }
    //     if (this.scrollContainer.scrollTop === 0) {
    //       this.isFn = true
    //       that.searchClick(1)
    //     }
    //   }
    // }

  }
};